import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { I18n } from 'react-redux-i18n';
import moment from 'moment';
import { connect } from 'react-redux';
import { Grid, Row, Col } from 'react-bootstrap';
import { GeneralGrid, DateCellRenderer, TimeCellRenderer, EditDeleteButtonRenderer } from '../../../_Common/Grids';
import { workItemSelectors, workItemTypes, workItemActions } from '../../../../redux/workItem';
import { taskSelectors, taskTypes, taskActions } from '../../../../redux/task';
import { applicationSelectors } from '../../../../redux/application';
import SearchForm from './SearchForm';
import { userSelectors } from '../../../../redux/user';
import { isNullOrUndef } from '../../../../utils/utils';
import { modalActions } from '../../../../redux/modal';
// import { taskActions } from '../../../../redux/task';
import WithPrivileges from '../../../_Common/WithPrivileges';
import userActionsCodes from '../../../../constants/userActionsCodes';
import { userRoleActions } from '../../../../redux/userRole';
import * as userRoles from '../../../../constants/userRoleTypes';
import DurationCellRenderer from '../../../_Common/Grids/DurationCellRenderer';
import { actionActions } from '../../../../redux/action';

class TaskList extends Component {
  constructor(props) {
    super(props);
    let expert = null;
    if (props.currentUserActionCodes.find(currentUserActionCode => currentUserActionCode === userActionsCodes.CalmosExpertAction) !== undefined) {
      expert = props.user.UserName;
    }
    this.state = {
      searchCriteria: {
        expert,
        statusFrom: moment()
          .format(),
        statusTo: moment()
          .format(),
        reachedStatus: 'TA04'
      },
      from: moment()
        .format(),
      to: moment()
        .format(),
      expert,
      reachedStatus: 'TA04'
    };
  }

  async componentDidMount() {
    await this.props.onLoad();
    const searchCriteria = this.state.searchCriteria;
    //this.props.getTaskList(searchCriteria);
  }

  search = () => {
    const searchCriteria = {
      statusFrom: this.state.from,
      statusTo: this.state.to,
      expert: this.state.expert,
      reachedStatus: this.state.reachedStatus
    };
    this.setState({ searchCriteria });
    this.props.getTaskList(searchCriteria);
  };

  fromChanged = from => {
    this.setState({ from });
  };

  toChanged = to => {
    this.setState({ to });
  };

  expertChanged = expert => {
    this.setState({ expert });
  };

  reachedStatusChanged = reachedStatus => {
    this.setState({ reachedStatus });
  };

  render() {
    const {
      isLoading,
      getTaskSelector,
      onDeleteButtonClick,
      onEditButtonClick,
    } = this.props;

    const taskList = getTaskSelector(this.state.searchCriteria);

    return (
      <WithPrivileges
        requiredActionCodes={[userActionsCodes.CalmosAdminAction, userActionsCodes.CalmosSuperAdminAction, userActionsCodes.CalmosExpertAction]}>
        {isAllowedToEditAdd => {
          const columns = [
            // {
            //   headerName: I18n.t('dailyRecords.orderNr'),
            //   field: 'TaskTypeOrderNr',
            //   width: 80,
            //   sort: 'asc',
            //   sortedAt: 3,
            // },
            {
              headerName: I18n.t('dailyRecords.orderNr'),
              field: 'OrderNumber',
              width: 60,
              sort: 'asc',
              sortedAt: 3,
            },
            {
              headerName: I18n.t('dailyRecords.company'),
              field: 'ProducerName',
              width: 120,
              sort: 'asc',
              sortedAt: 2,
            },
            {
              headerName: I18n.t('dailyRecords.productCode'),
              field: 'ProductCode',
              width: 80,
              sort: 'asc',
              sortedAt: 4,
            },
            {
              headerName: I18n.t('dailyRecords.productName'),
              field: 'ProductName',
            },
            {
              headerName: I18n.t('dailyRecords.processType'),
              field: 'ProcessTypeCode',
              width: 80,
              sort: 'asc',
              sortedAt: 5,
            },
            {
              headerName: I18n.t('dailyRecords.region'),
              field: 'RegionValue',
              width: 60,
              sort: 'asc',
              sortedAt: 6,
            },
            {
              headerName: I18n.t('dailyRecords.task'),
              field: 'TaskTypeName',
              sort: 'asc',
              sortedAt: 7,
            },
            {
              headerName: I18n.t('orderTask.expert'),
              field: 'Expert',
              width: 70,
            },
            {
              headerName: I18n.t('dailyRecords.expectedDuration'),
              field: 'ExpectedDuration',
              cellRenderer: DurationCellRenderer,
              width: 60,
            },
            // {
            //   headerName: I18n.t('dailyRecords.startDate'),
            //   field: 'StartedOn',
            //   cellRenderer: DateCellRenderer,
            //   cellRendererParams: {
            //     includeHours: false,
            //   },
            //   width: 85,
            //   sort: 'desc',
            //   sortedAt: 1,
            // },
            // {
            //   headerName: I18n.t('dailyRecords.startTime'),
            //   field: 'StartedOn',
            //   cellRenderer: TimeCellRenderer,
            //   width: 85,
            //   suppressSorting: true,
            // },
            // {
            //   headerName: I18n.t('dailyRecords.duration'),
            //   field: 'DurationDone',
            //   cellRenderer: DurationCellRenderer,
            //   width: 80,
            // },
            // {
            //   headerName: I18n.t('dailyRecords.endTime'),
            //   field: 'FinishedOn',
            //   cellRenderer: TimeCellRenderer,
            //   width: 85,
            // },
            {
              headerName: I18n.t('dailyRecords.statusReachedOn'),
              field: 'StatusReachedOn',
              cellRenderer: DateCellRenderer,
              width: 85,
            },            // {
            //   headerName: I18n.t('general.actions'),
            //   cellRendererFramework: EditDeleteButtonRenderer,
            //   suppressSizeToFit: true,
            //   hide: !isAllowedToEditAdd,
            //   width: 120,
            //   cellRendererParams: {
            //     onDelete: ({ WorkItemId }) => onDeleteButtonClick({
            //       WorkItemId,
            //       searchCriteria: this.state.searchCriteria,
            //     }),
            //     onEdit: ({ WorkItemId }) => onEditButtonClick({
            //       WorkItemId,
            //       searchCriteria: this.state.searchCriteria,
            //     }),
            //   },
            // },
          ];

          return (<Grid fluid>
            <Row style={{ marginBottom: '5px' }}>
              <SearchForm
                from={this.state.from}
                to={this.state.to}
                expert={this.state.expert}
                reachedStatus={this.state.reachedStatus}
                search={this.search}
                fromChanged={this.fromChanged}
                toChanged={this.toChanged}
                expertChanged={this.expertChanged}
                reachedStatusChanged={this.reachedStatusChanged}
                user={this.props.user}
                currentUserActionCodes={this.props.currentUserActionCodes}
              />
            </Row>
            <Row>
              <Col sm={12}>
                <GeneralGrid
                  data={taskList}
                  columns={columns}
                  keyName="TaskId"
                  isLoading={isLoading}
                  onRefresh={() => this.search(this.state.searchCriteria)}
                />
              </Col>
            </Row>
          </Grid>);
        }}
      </WithPrivileges>
    );
  }
}

const mapStateToProps = (state, props) => {
  const getTaskSelector = taskSelectors.makeGetByQuery(state);
  return {
    getTaskSelector,
    isLoading: applicationSelectors.isLoading(state, workItemTypes.WORK_ITEM_LIST.REQUEST),
    user: userSelectors.getCurrentUser(state),
    currentUserActionCodes: userSelectors.getCurrentUserActionCodes(state),
  };
};

const mapDispatchToProps = dispatch => ({
  onLoad: () => {
    dispatch(userRoleActions.listUserRoleForRoles.request([userRoles.default.expert]));
    dispatch(actionActions.listActions.request());
  },
  // getWorkItemList: searchCriteria => dispatch(workItemActions.listWorkItems.request(searchCriteria)),
  getTaskList: searchCriteria => {
    dispatch(taskActions.listTasks.request(searchCriteria));
  },
  onEditButtonClick: ({ WorkItemId, searchCriteria }) =>
    dispatch(
      modalActions.showWorkItemFormModal({
        WorkItemId,
        searchCriteria,
      }),
    ),
  onDeleteButtonClick: ({ WorkItemId, searchCriteria }) => dispatch(taskActions.deleteTask.request({
    WorkItemId,
    searchCriteria,
  })),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(TaskList);

TaskList.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  getTaskSelector: PropTypes.func.isRequired,
  getTaskList: PropTypes.func.isRequired,
  // getWorkItemSelector: PropTypes.func.isRequired,
  // getWorkItemList: PropTypes.func.isRequired,
  user: PropTypes.shape({
    UserName: PropTypes.string.isRequired,
  }).isRequired,
  onEditButtonClick: PropTypes.func.isRequired,
  onDeleteButtonClick: PropTypes.func.isRequired,
  onLoad: PropTypes.func.isRequired,
  currentUserActionCodes: PropTypes.arrayOf(PropTypes.string).isRequired,
};
